import React, { lazy, Suspense } from 'react';
import CWOConfigProvider from 'helpers/cwoConfigProvider';
import Loading from 'helpers/loading/loading';

// eslint-disable-next-line @stylistic/max-len
const Component = lazy(() => import('components/fuel-station-objects/fuel-station-object-status-icon'));

const FuelStationObjectStatusIcon = (props) => (
  <CWOConfigProvider>
    <Suspense fallback={<Loading />}>
      <Component {...props} />
    </Suspense>
  </CWOConfigProvider>
);

export default FuelStationObjectStatusIcon;
